import * as React from 'react'

import { cn } from '../../lib/utils'

/**
 * The strip of page-level controls that sits above a card: a period selector,
 * a platform switch, a refresh, a primary action. A surface, not a control set
 * — <DataTableToolbar> is the search-and-filter row for a table, and the two
 * stack happily, this one on top.
 *
 * It carries no outer margin on purpose: the page decides its own spacing.
 */
function ControlBar({ className, children, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="control-bar"
      className={cn(
        'border-border bg-bg-faint flex flex-wrap items-center justify-between gap-3 rounded-xl border px-2.5 py-2.5 shadow-2xs',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

/** Groups controls that belong together inside a <ControlBar>. */
function ControlBarGroup({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="control-bar-group"
      className={cn('flex min-w-0 flex-wrap items-center gap-2.5', className)}
      {...props}
    />
  )
}

export { ControlBar, ControlBarGroup }
